import { SearchActions } from "~/types/actions.enum";
import { ResultType } from "~/features/Search/Results/types";

// ✅ Initial states
export const initialState: TTabState = {
    tabs: [],
    tab: null
};

// ✅ Types

// Action type defn
export type TabAction =
    | { type: SearchActions.SET_TAB_ITEMS; payload: SearchTab[] }
    | { type: SearchActions.SET_ACTIVETAB; payload: SearchTab | null }
    | { type: SearchActions.SET_ACTIVETAB_BY_KEY; payload: TabKeys | null };

// State type defns
export type TabKeys = Exclude<ResultType, "marketIntelligence">;

export type SearchTab = {
    /** Numeric unique ID */
    id: number;
    /** Search tab key name */
    key: TabKeys;
};

export type TTabState = {
    /** List of V3 search page tab keys `SearchTab[]` */
    tabs: SearchTab[];
    /** Active/selected tab `SearchTab` */
    tab: SearchTab | null;
};

// Store type
export type TTabMethods = "dispatch" | "getTabKeys" | "reset";

export type TTabStore = TTabState & {
    /**
     * Sets the Tabs state using a reducer pattern.
     * @param {TabAction} action - `TabAction` action to apply.
     * @example
     * ```
     * const dispatch = useTabStore((state) => state.dispatch)
     * dispatch({ type: SearchActions.SET_TAB_ITEM, payload: tabItem })
     * ```
     */
    dispatch: (action: TabAction) => void;
    /**
     * Retrieves the values of all `SearchTab.key`
     */
    getTabKeys: () => string[];
    /**
     * Resets the store to its initial state
     */
    reset: () => void;
};
